import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl-next';
import FlexibleCard from '../../../../FlexibleCard';
import { messages } from '../../../../../messages';
import { CustomBlock } from '../../../../FlexibleCard/components/blocks';
import { extractProvider } from '@atlaskit/link-extractors';
import { connectButtonStyles, mainTextStyles, titleBlockStyles } from './styled';
import UnauthorisedViewContent from '../../../../common/UnauthorisedViewContent';
import ActionGroup from '../../../../FlexibleCard/components/blocks/action-group';
import { LinkIcon } from '../../../../FlexibleCard/components/elements';
import { ActionName, CardDisplay } from '../../../../../constants';
import { useSmartCardActions } from '../../../../../state/actions';
import { hasAuthScopeOverrides } from '../../../../../state/helpers';
var HoverCardUnauthorisedView = function HoverCardUnauthorisedView(_ref) {
  var _cardState$details, _extractProvider;
  var analytics = _ref.analytics,
    extensionKey = _ref.extensionKey,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    flexibleCardProps = _ref.flexibleCardProps,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'hover-card-unauthorised-view' : _ref$testId,
    url = _ref.url;
  var cardState = flexibleCardProps.cardState;
  var data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
  var providerName = (_extractProvider = extractProvider(data)) === null || _extractProvider === void 0 ? void 0 : _extractProvider.text;
  var isProductIntegrationSupported = hasAuthScopeOverrides(cardState.details);
  var _useSmartCardActions = useSmartCardActions(id, url, analytics),
    authorize = _useSmartCardActions.authorize;
  var handleAuthorize = useCallback(function () {
    if (authorize) {
      analytics.track.appAccountAuthStarted({
        extensionKey: extensionKey
      });
      authorize(CardDisplay.HoverCardPreview);
    }
  }, [authorize, extensionKey, analytics.track]);
  var actions = useMemo(function () {
    return [{
      name: ActionName.CustomAction,
      content: /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_unauthorised_account_action, {
        values: {
          context: providerName
        }
      })),
      onClick: handleAuthorize
    }];
  }, [handleAuthorize, providerName]);
  return /*#__PURE__*/React.createElement(FlexibleCard, _extends({}, flexibleCardProps, {
    testId: testId
  }), /*#__PURE__*/React.createElement(CustomBlock, {
    overrideCss: titleBlockStyles,
    testId: "".concat(testId, "-title")
  }, /*#__PURE__*/React.createElement(LinkIcon, null), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.connect_link_account_card_name, {
    values: {
      context: providerName
    }
  }))), /*#__PURE__*/React.createElement(CustomBlock, {
    overrideCss: mainTextStyles,
    testId: "".concat(testId, "-content")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UnauthorisedViewContent, {
    providerName: providerName,
    isProductIntegrationSupported: isProductIntegrationSupported,
    analytics: analytics
  }))), /*#__PURE__*/React.createElement(CustomBlock, {
    overrideCss: connectButtonStyles,
    testId: "".concat(testId, "-button")
  }, /*#__PURE__*/React.createElement(ActionGroup, {
    items: actions,
    appearance: "primary"
  })));
};
export default HoverCardUnauthorisedView;